import { Checkbox } from '@mantine/core';
import classes from './Checkbox.module.css';

export const CheckboxConfig = Checkbox.extend({
  classNames: {
    input: classes.input,
  },
});
